<template>
	<ValidationProvider :name="idLabel" :rules="{ required: required }" :immediate="immediate" v-slot="{ failed }" slim>
		<div :class="{ 'form-group': true, visited: value || focused, 'is-invalid-wrapper': failed }">
			<label :for="$id('text-input')" class="col-form-label form-control-placeholder">
				{{ label }}
				<span class="required" v-if="required">*</span>
			</label>
			<input
				type="text"
				:class="{ 'form-control': true, 'is-invalid': failed }"
				:id="$id('text-input')"
				:name="$id('text-input')"
				:value="value"
				@input="$emit('input', $event.target.value)"
				@focus="focused = true"
				@blur="focused = false"
			/>
		</div>
	</ValidationProvider>
</template>

<script>
import { ValidationProvider } from 'vee-validate';
import formControlProps from '../Mixins/formControlProps';
import validationProps from '../Mixins/validationProps';
import '../Utils/validation';

export default {
	mixins: [formControlProps, validationProps],

	data() {
		return {
			focused: false,
		};
	},

	components: {
		ValidationProvider,
	},
};
</script>
